import React, { useState, useEffect, } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IonContent, IonHeader, IonPage, IonButton,
         IonIcon, IonLabel, IonLoading, IonAlert, IonList } from '@ionic/react';
import { ActivityTypes, ActivityColors, EnumTimePeriods, EnumPersons } from '../domain/enums';
import { IActivityLogSearchResult, ILogSearch_Response } from '../domain/ActivityLog';
import { getActivityLogListAsync } from '../services/asyncDataService';
import HeaderApp from '../components/HeaderApp';
import { HomeParams } from '../domain/MobileApp';
import { Plugins } from '@capacitor/core';
import { ellipse } from 'ionicons/icons';
import './css/Home.css';

const { Network } = Plugins;

const ExternalHome: React.FC<RouteComponentProps> = ({history, location, match}) => {
  const [showLoading, setShowLoading] = useState(false);
  const [pinValue, setPinValue] = useState(0);
  const [recentValue, setRecentValue] = useState(0);
  const [isOnline, setIsOnline] = useState<boolean>(window.localStorage.getItem("online") !== "0");
  const [showToast, setShowToast] = useState(false);
  const [myException, setMyException] = useState("");
  const [errorVisible, setErrorVisible] = useState(false);

  const _permitId = (match.params as HomeParams).permitId || 0;
  const _mooringId = (match.params as HomeParams).mooringId || 0;
  const _personId = (match.params as HomeParams).personId || 0;
  const _boatId = (match.params as HomeParams).boatId || 0;

  useEffect(() => {
    Network.addListener("networkStatusChange", status => {
      setIsOnline(status.connected);
      if (status.connected)
        window.localStorage.setItem("online", "1");
      else
        window.localStorage.setItem("online", "0");
    });

    return () => Network.removeAllListeners();
  },[])

  useEffect(() => {
    let _token = window.localStorage.getItem("token");

    if (_token && isOnline)
      tokenAndOnline();
    else
      setShowToast(true);
  },[isOnline]);

  const tokenAndOnline = async() => {
    let _token = String(window.localStorage.getItem("token"));
    let _client = window.localStorage.getItem("defaultClient") ? String(window.localStorage.getItem("defaultClient")) : '-1' ;
    setShowLoading(true);
          
    //call to display pin value
    console.log("call to display pin value");
    let expectedDataPinned = await getActivityLogListAsync(_token, _client, EnumTimePeriods.All.toString(), '', '', 
                                                EnumPersons.All.toString(), '', Number(ActivityTypes.All), true , '', 
                                                false);
    if (expectedDataPinned && expectedDataPinned.data) {
      let activityLogPinnedList = (JSON.parse(expectedDataPinned.data.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
      if (activityLogPinnedList.length > 0) {
        console.log("call to display pin value - length > 0");
        window.localStorage.setItem("pinValue", activityLogPinnedList.length.toString());
        setPinValue(activityLogPinnedList.length);
      }
      setShowLoading(false);
    }
    else {
      setMyException("Details: " + JSON.stringify((expectedDataPinned as any)));
      setShowLoading(false);
      setErrorVisible(true);
    }
        
    setShowLoading(true);
    //call to display recent value
    console.log("call to display recent value");
    let expectedDataRecent = await getActivityLogListAsync(_token, _client, EnumTimePeriods['Past 24 Hours'].toString(), '', '', 
                                            EnumPersons.All.toString(), '', Number(ActivityTypes.All), false , '', 
                                            false);
    if (expectedDataRecent && expectedDataRecent.data) {
      let activityLogRecentList = (JSON.parse(expectedDataRecent.data.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
      if (activityLogRecentList.length > 0) {
        console.log("call to display recent value - length > 0");
        window.localStorage.setItem("recentValue", activityLogRecentList.length.toString());
        setRecentValue(activityLogRecentList.length);
      }
      setShowLoading(false);
    }
    else {
      setMyException("Details: " + JSON.stringify((expectedDataRecent as any)));
      setErrorVisible(true);
      setShowLoading(false);
    }
  }


  const createActivityLog = (activityType: string) => {
    if (isOnline) {
      if (!window.localStorage.getItem("defaultClient"))
        history.push('/activity/0/0/' + activityType 
                + '/1'
                + '/' + _permitId
                + '/' + _mooringId
                + '/' + _personId
                + '/' + _boatId); 
      else {
        let clientId = String(window.localStorage.getItem("defaultClient")); 
        history.push('/activity/0/' + clientId + '/' + activityType 
                + '/1'
                + '/' + _permitId
                + '/' + _mooringId
                + '/' + _personId
                + '/' + _boatId); 
      }
    }
    else 
      setShowToast(true);
  }

  return (
    <IonPage>
      <IonHeader mode="ios">
          <HeaderApp pinValue={pinValue} recentValue={recentValue} history={history} location={location} match={match} isOnline={isOnline}></HeaderApp>
      </IonHeader>
      <IonContent fullscreen>
            <IonHeader className="my-external-activities-header">
                <IonLabel className="my-external-activities-label">{"Please select the activity type to add"}</IonLabel>
            </IonHeader>
            <IonList mode="ios" className="my-external-activities-list">
              { Object.keys(ActivityTypes).filter((x:any) => !isNaN(Number(ActivityTypes[x])) && Number(ActivityTypes[x]) !== 0)
                  .sort ((a:any,b:any) => Number(ActivityTypes[a]) - Number(ActivityTypes[b]))
                  .map((x:any) => {
                    return (
                      <IonButton mode="ios" className="my-external-activities-button" color="light" key={ActivityTypes[x]} onClick={() => {createActivityLog(ActivityTypes[x])}}>
                        <IonIcon slot="start" mode="ios" icon={ellipse} color={ActivityColors[Number(ActivityTypes[x])]} size="medium"></IonIcon> 
                        <IonLabel mode="ios">{x}</IonLabel>
                      </IonButton> 
                    )
                  })
              }  
            </IonList>
      </IonContent>
      <IonLoading mode="ios"
        cssClass='my-loading'
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={'Getting data...'}
      />
       <IonAlert mode="ios"
        isOpen={errorVisible}
        onDidDismiss={() => setErrorVisible(false)}
        cssClass='my-custom-class'
        header={'Error'}
        subHeader={myException}
        message={''}
        buttons={['OK']}
      /> 
      <IonAlert mode="ios"
          isOpen={showToast}
          onDidDismiss={() => setShowToast(false)}
          cssClass='my-custom-class'
          header={'Warning'}
          subHeader={''}
          message={'You are in offline mode'}
          buttons={['OK']}
      /> 
    </IonPage>
  );
};

export default ExternalHome;